import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { storeCleanup } from '~SpectateStore/actions/storeCleanupActions';
import {
    dataPointersUpdate,
} from '~SpectateStore/actions/dataPointersActions';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';


export const uiMarketsAdapter = createEntityAdapter();

const uiMarketsSlice = createSlice({
    name: 'uiMarkets',
    initialState: uiMarketsAdapter.getInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                storeCleanup,
                (state, { payload : { eventIds } }) => {
                    const idsForDeletion = [];

                    state.ids.forEach(uiMarketId => {
                        const uiMarket = state.entities[uiMarketId];
                        if (eventIds.includes(uiMarket.event_id)) {
                            idsForDeletion.push(uiMarket.id);
                        }
                    });

                    if (idsForDeletion.length) {
                        uiMarketsAdapter.removeMany(state, idsForDeletion);
                    }
                },
            )
            .addCase(
                inplayEventData.fulfilled,
                (state, { payload : { uiMarkets } }) => {
                    if (Object.keys(uiMarkets).length > 0) {
                        return uiMarketsAdapter.addMany(state, uiMarkets);
                    }

                    return state;
                },
            )
            .addCase(
                dataPointersUpdate,
                (state, { payload : { uiMarkets = {} } }) => {
                    if (Object.keys(uiMarkets).length > 0) {
                        return uiMarketsAdapter.addMany(state, uiMarkets);
                    }

                    return state;
                },
            )
            .addCase(
                eventInplayStart,
                (state, { payload : { uiMarkets = {} } }) => {
                    if (Object.keys(uiMarkets).length > 0) {
                        return uiMarketsAdapter.addMany(state, uiMarkets);
                    }

                    return state;
                },
            );
    },
});

export default uiMarketsSlice.reducer;
